import { useTranslation } from 'react-i18next';

import { DisregardEventResponse } from '@/app/models/disregardEvents';
import DataTable, { type Column, bodyCellSx } from '@/components/common/DataTable';
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton, TableCell } from '@mui/material';

interface NewConsiderCollaboratorTableProps {
  collaborators: DisregardEventResponse[];
  onRemove: (collaborator: string) => void;
}

export default function NewDisregardEventsTable({ collaborators, onRemove }: NewConsiderCollaboratorTableProps) {
  const { t } = useTranslation('disregardEvents');

  const handleDelete = (id: string) => {
    if (id) {
      onRemove(id);
    }
  };

  const columns: Column[] = [
    {
      key: 'events',
      label: t('events'),
      align: 'left',
      width: '80%',
    },
    {
      key: 'actions',
      label: '',
      align: 'center',
      width: '20%',
    },
  ];

  const renderRow = (collaborator: DisregardEventResponse) => (
    <>
      <TableCell sx={bodyCellSx}>{`${collaborator.code} - ${collaborator.name}`}</TableCell>
      <TableCell sx={bodyCellSx} align="center">
        <IconButton size="small" onClick={() => handleDelete(collaborator.code)}>
          <DeleteIcon fontSize="small" />
        </IconButton>
      </TableCell>
    </>
  );

  const getRowKey = (collaborator: DisregardEventResponse) => collaborator.code;

  return (
    <DataTable
      columns={columns}
      data={collaborators}
      renderRow={renderRow}
      emptyMessage={t('no.events.selected')}
      getRowKey={getRowKey}
      size="small"
      stickyHeader={false}
    />
  );
}
